import { DirectUpload } from "@rails/activestorage"
//https://guides.rubyonrails.org/active_storage_overview.html
class Uploader {
  constructor({ file, url, onProgress, onSuccess, onError }) {
    this.upload = new DirectUpload(file, url, this)
    this.onProgress = onProgress

    this.upload.create((error, blob) => {
      if (error) {
        onError(error);
      } else {
        onSuccess(blob);
      }
    })
  }
  // This is the way to be able to get progress events
  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event))
  }
  // This way we process the progress event with callback given in the constructor
  directUploadDidProgress(event) {
    if (this.onProgress) {
      this.onProgress(event);
    }
  }
}

export default Uploader
